import { type WorkflowNode } from '@blaze-shared/workflow-domain';

import { type SchemaProvider, SchemaProviderRegistry } from '../registry/schema-provider.registry';

export class SchemaProviderFactory {
  static createSchemaProvider<T extends WorkflowNode>(node: T): SchemaProvider<T> {
    const schemaProviderClass = SchemaProviderRegistry.getSchemaProvider(node.nodeType);

    return new schemaProviderClass();
  }
}
